import store from '../../../store'
import pwa_payments from "./list/pwa_payments.vue";

window.PWA_PAYMENTS=  new Vue({
    store,
    el: '#pwa_payments',

    data () {
        return {

        }
    },
    created () {

    },
    components : {
        pwa_payments
    }
});
